/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */


if (!customElements.get('variant-picker')) {
  const RESTOCK_FALLBACK_WAREHOUSE = {
    us: 'PM-DTC-US',
    uk: 'PM-DTC-UK',
    eu: 'PM-DTC-EU',
    ca: 'PM-DTC-US'
  };

  /**
   * SMART SELECTION VARIANT PICKER
   * 
   * This enhanced variant picker enables smart selection behavior for NON-COLOR, NON-DROPDOWN options:
   * - Users can click on diameter/net weight options that exist anywhere (not just with current selection)
   * - System automatically selects the best matching variant when user clicks a non-color, non-dropdown option
   * - Smart selection prioritizes keeping the same color if it exists with the new option
   * - Color options and dropdown options use normal restrictive logic (only work with current selection, no smart selection)
   * - Non-color, non-dropdown options are permissive (show if they exist anywhere)
   * 
   * Example: User on "1.75mm + White" clicks "5kg" → stays "1.75mm + 5kg + White" (if White exists with 5kg)
   * Example: User on "1.75mm + Black" clicks "2.85mm" → switches to "2.85mm + Orange" (if Black doesn't exist with 2.85mm)
   * Example: User on "1.75mm + 3kg" clicks "Blue" → stays "1.75mm + 3kg + Blue" (no smart selection)
   * Example: User on color_dropdown template → no smart selection (dropdown selectors disabled)
   */
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.setupRestockConfig();

      // Quick-add drawer fetches product HTML with ?variant=… but window.location is still the collection page.
      const quickAddDrawer = this.closest('quick-add-drawer');
      let urlVariant = null;
      if (quickAddDrawer && quickAddDrawer.dataset.pendingVariantId) {
        urlVariant = quickAddDrawer.dataset.pendingVariantId;
        quickAddDrawer.removeAttribute('data-pending-variant-id');
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        urlVariant = urlParams.get('variant');
      }
      this.originalVariantId = urlVariant;
      
      // Flag to prevent URL updates during URL-based initialization
      this.isInitializingFromUrl = false;
      
      // Check for variant parameter in URL and set initial selection
      this.initializeFromUrlVariant();
      
      let operateSetting = $('.overallContent').attr('data-switch');
      if (operateSetting === 'true') {
            this.lastVariantId = null; // 存储上一个处理过的 variantId
            this.sameCount = 0; // 记录连续相同 variantId 的点击次数
            this.sameCount1 = 0; // 记录连续相同 variantId 的点击次数
            this.lastQuickId = null; // 保存上一个 quickId
            this.executeOnce = false; // 在类的构造函数中初始化
      
        } 
     

      this.updateAvailability();
      this.updateAddToCartButton();
      this.updateRestockEstimate();
      this.addEventListener('change', this.handleVariantChange.bind(this));
      
      // CRITICAL: Enforce URL variant BEFORE initializing first variant
      // This ensures URL variant takes precedence over default first variant selection
      if (this.originalVariantId) {
        // If URL has variant, enforce it immediately and skip first variant initialization
        setTimeout(() => {
          this.forceCorrectVariantFromUrl();
        }, 100);
      } else {
        // Only initialize first variant if no URL variant exists
        this.initializeFirstVariant();
      }
      
      // Additional enforcement after a longer delay to catch any race conditions
      if (this.originalVariantId) {
        setTimeout(() => {
          this.forceCorrectVariantFromUrl();
        }, 300);
      }
      
      
      
              // Add smart selection click listeners to option inputs
              // This enables clicking on NON-COLOR options that exist anywhere (not just with current selection)
              // Color options use normal restrictive selection logic to stay within current selection
              
              
              this.optionSelectors.forEach((selector, selectorIndex) => {
                const inputs = selector.querySelectorAll('input.js-option');
                
                
                inputs.forEach((input, inputIndex) => {
                  input.addEventListener('click', () => {
                    
                    setTimeout(() => {
                      const clickedOptionValue = input.value;
                      const clickedSelectorIndex = this.getSelectorIndex(input);
                      
                      // Check if this is a color selector (swatch) or dropdown selector
                      const isColorSelector = this.optionSelectors[clickedSelectorIndex].querySelector('.opt-label--swatch') !== null;
                      const isDropdownSelector = this.optionSelectors[clickedSelectorIndex].dataset.selectorType === 'dropdown';
                      
                      
                      // Apply smart selection to color swatches when draft variants exist
                      // This fixes the issue where color swatches don't work when variants are set to draft
                      const hasDraftVariants = this.dataset.variantMetafields && this.dataset.variantMetafields !== '[]';
                      
                      if ((!isColorSelector && !isDropdownSelector) || (isColorSelector && hasDraftVariants)) {
                        // SMART SELECTION: Only apply to non-color, non-dropdown options (diameter, net weight, etc.)
                        // This enables users to click on options that exist anywhere, not just with current selection
                        // Dropdown selectors (like in color_dropdown template) are excluded from smart selection
                        
                        // Check if clicked option exists in any variant
                        const hasAnyVariant = this.checkIfOptionHasAnyVariant(clickedOptionValue, clickedSelectorIndex);
                        
                        
                        if (hasAnyVariant) {
                          let bestVariant;
                          
                          if (isColorSelector) {
                            // For color selections, find variant that matches the clicked color while preserving other selections
                            const currentOptions = this.getSelectedOptions();
                            bestVariant = this.data.product.variants.find(variant => {
                              // Check if this variant matches the clicked color
                              if (variant.options[clickedSelectorIndex] !== clickedOptionValue) {
                                return false;
                              }
                              
                              // Check if this variant preserves all other current selections
                              for (let i = 0; i < currentOptions.length; i++) {
                                if (i !== clickedSelectorIndex && variant.options[i] !== currentOptions[i]) {
                                  return false;
                                }
                              }
                              
                              return true;
                            });
                          } else {
                            // For non-color selections, use the existing smart selection logic
                            bestVariant = this.findFirstAvailableVariant(clickedOptionValue, clickedSelectorIndex);
                          }
                          
                          if (bestVariant) {
                            // PHASE 1: Update all selectors to match the new variant
                            this.updateSelectorsToVariant(bestVariant);
                            
                            // PHASE 2: Update variant picker state
                            this.variant = bestVariant;
                            this.updateVariantInput();
                            
                            // PHASE 3: Update variant input and dispatch change event
                            // This ensures third-party apps receive proper events without infinite loops
                            this.updateVariantInput();
                            
                            // Dispatch variant change event for third-party apps
                            this.dispatchEvent(new CustomEvent('on:variant:change', {
                              bubbles: true,
                              detail: {
                                form: this.productForm,
                                variant: bestVariant,
                                product: this.data.product
                              }
                            }));
                            
                            // PHASE 4: Update all UI elements with a small delay to ensure DOM updates are complete
                            setTimeout(() => {
                              this.updateMedia();           // Product images
                              this.updatePrice();           // Pricing display
                              this.updateWeight();          // Weight display
                              this.updateBarcode();         // Barcode display
                              this.updateSku();             // SKU display
                              this.updateHexCode();         // Color hex code and label
                              this.updateTransmissionDistance(); // Transmission distance
                              this.updateRestockEstimate(); // Restock estimate
                              this.updateBackorderText();   // Backorder messaging
                              this.updatePickupAvailability(); // Pickup availability
                              this.updateAddToCartButton(); // Add to cart button
                              this.updateAvailability();    // Availability status
                              this.updateAllColorLabels();  // Color text labels
                            }, 10);
                          }
                        }
                      }
                      // For color selectors and dropdown selectors, let the normal variant selection logic handle it
                      // This ensures color swatches and dropdown options work exactly as before (no smart selection)
                      
                      // Update swatch visibility after selection change
                      const selectedOptions = this.getSelectedOptions();
                      this.updateSwatchVisibility(selectedOptions);
                    }, 50);
                  });
                });
              });
      
      // Initial swatch visibility update
      setTimeout(() => {
        const selectedOptions = this.getSelectedOptions();
        this.updateSwatchVisibility(selectedOptions);
      }, 100);
    }

    setupRestockConfig() {
      this.restockMessage = this.querySelector('.js-variant-restock-message');
      this.restockEnabled = this.dataset.restockEnabled === 'true';
      if (!this.restockEnabled || !this.restockMessage) return;
      this.restockMarketHandle = (this.dataset.restockMarketHandle || '').trim().toLowerCase();
      this.restockWarehouseMap = this.parseRestockWarehouseMap(this.dataset.restockWarehouseMap || '');
      this.restockLabel = this.dataset.restockLabel || 'Estimated Restock Date:';
      this.restockEarly = this.dataset.restockEarly || 'Early';
      this.restockMid = this.dataset.restockMid || 'Mid';
      this.restockLate = this.dataset.restockLate || 'Late';
      this.restockSubtext = 'Dates subject to change';
      this.restockMonthFormatter = new Intl.DateTimeFormat(document.documentElement?.lang || undefined, {
        month: 'long',
        timeZone: 'UTC'
      });
      this.restockMonthShortFormatter = new Intl.DateTimeFormat(document.documentElement?.lang || undefined, {
        month: 'short',
        timeZone: 'UTC'
      });
      this.customerTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
      this.customerDateKeyFormatter = new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: this.customerTimeZone
      });
    }

    parseRestockWarehouseMap(rawMap) {
      const map = {};
      if (!rawMap) return map;
      for (const line of rawMap.split(/\r?\n/)) {
        const trimmed = line.trim();
        if (!trimmed || trimmed[0] === '#') continue;
        const separatorIndex = trimmed.indexOf(':');
        if (separatorIndex <= 0) continue;
        const marketKey = trimmed.slice(0, separatorIndex).trim().toLowerCase();
        const warehouseKey = trimmed.slice(separatorIndex + 1).trim();
        if (marketKey && warehouseKey) {
          map[marketKey] = warehouseKey;
        }
      }
      return map;
    }

    resolveRestockWarehouseKey(marketHandle) {
      if (!marketHandle) return '';
      if (this.restockWarehouseMap[marketHandle]) return this.restockWarehouseMap[marketHandle];
      return RESTOCK_FALLBACK_WAREHOUSE[marketHandle] || '';
    }

    getRestockDatesMap(restockRaw) {
      if (!restockRaw) return null;
      if (typeof restockRaw === 'object') return restockRaw;
      if (typeof restockRaw !== 'string') return null;
      try {
        const parsed = JSON.parse(restockRaw);
        return typeof parsed === 'object' && parsed ? parsed : null;
      } catch {
        return null;
      }
    }

    formatRestockWindow(dateText) {
      const parsed = this.parseRestockDate(dateText);
      if (!parsed) return '';
      const prefix = parsed.day <= 10 ? this.restockEarly : parsed.day <= 20 ? this.restockMid : this.restockLate;
      return `${prefix} ${this.restockMonthFormatter.format(parsed.dateUtc)}`;
    }

    parseRestockDate(dateText) {
      if (typeof dateText !== 'string') return null;
      const match = dateText.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return null;
      const monthIndex = Number(match[2]) - 1;
      const day = Number(match[3]);
      const year = Number(match[1]);
      if (monthIndex < 0 || monthIndex > 11 || day < 1 || day > 31) return null;
      const dateUtc = new Date(Date.UTC(year, monthIndex, day));
      if (
        Number.isNaN(dateUtc.getTime())
        || dateUtc.getUTCMonth() !== monthIndex
        || dateUtc.getUTCDate() !== day
      ) {
        return null;
      }
      return { dateUtc, day, year, month: monthIndex + 1 };
    }

    getDateKeyInCustomerTimeZone(dateObj) {
      // Use YYYY-MM-DD in the customer's browser timezone for stable calendar-day comparisons.
      return this.customerDateKeyFormatter.format(dateObj);
    }

    isPastRestockDate(dateText) {
      const parsed = this.parseRestockDate(dateText);
      if (!parsed) return false;
      const month = String(parsed.month).padStart(2, '0');
      const day = String(parsed.day).padStart(2, '0');
      const restockDateKey = `${parsed.year}-${month}-${day}`;
      const todayKey = this.getDateKeyInCustomerTimeZone(new Date());
      return todayKey > restockDateKey;
    }

    getRestockCalendarMonth(dateText) {
      const parsed = this.parseRestockDate(dateText);
      if (!parsed) return '';
      return this.restockMonthShortFormatter.format(parsed.dateUtc).toUpperCase();
    }

    setRestockMessage(text, calendarMonth = '') {
      if (!this.restockMessage) return;
      if (!text) {
        this.restockMessage.replaceChildren();
        this.restockMessage.hidden = true;
        return;
      }
      let displayLabel = String(this.restockLabel || 'Estimated Restock Date:').trim();
      displayLabel = displayLabel.replace(/:\s*$/, '');

      const wrap = document.createElement('div');
      wrap.className = 'restock-notice';

      const cal = document.createElement('div');
      cal.className = 'restock-notice__cal';
      cal.setAttribute('aria-hidden', 'true');

      const calTop = document.createElement('div');
      calTop.className = 'restock-notice__cal-top';

      const calBody = document.createElement('div');
      calBody.className = 'restock-notice__cal-body';
      const calMonth = document.createElement('span');
      calMonth.className = 'restock-notice__cal-month';
      calMonth.textContent = calendarMonth || 'ETA';
      calBody.append(calMonth);
      cal.append(calTop, calBody);

      const info = document.createElement('div');
      info.className = 'restock-notice__info';

      const main = document.createElement('div');
      main.className = 'restock-notice__main';
      const mainLabel = document.createElement('strong');
      mainLabel.className = 'restock-notice__label';
      mainLabel.textContent = `${displayLabel}:`;
      const mainDate = document.createElement('span');
      mainDate.className = 'restock-notice__date';
      mainDate.textContent = ` ${text}`;
      main.append(mainLabel, mainDate);

      const sub = document.createElement('div');
      sub.className = 'restock-notice__sub';
      sub.textContent = this.restockSubtext;

      info.append(main, sub);
      wrap.append(cal, info);
      this.restockMessage.replaceChildren(wrap);
      this.restockMessage.hidden = false;
    }

    updateRestockEstimate() {
      if (!this.restockEnabled || !this.restockMessage || !this.variant) {
        this.setRestockMessage('');
        return;
      }
      // Show restock estimate only when selected variant is out of stock in current market context.
      // `variant.available` comes from Shopify storefront data for the active market.
      if (this.variant.available) {
        this.setRestockMessage('');
        return;
      }
      const restockDates = this.getRestockDatesMap(this.variant.variant_restock_date);
      if (!restockDates) {
        this.setRestockMessage('');
        return;
      }

      let warehouseKey = this.restockMarketHandle
        ? this.resolveRestockWarehouseKey(this.restockMarketHandle)
        : '';
      if (!warehouseKey) {
        const keys = Object.keys(restockDates);
        if (keys.length === 1) warehouseKey = keys[0];
        else if (!this.restockMarketHandle) warehouseKey = this.resolveRestockWarehouseKey('us');
      }
      if (!warehouseKey) {
        this.setRestockMessage('');
        return;
      }

      const exactDate = restockDates[warehouseKey]
        || restockDates[warehouseKey.toUpperCase()]
        || restockDates[warehouseKey.toLowerCase()];
      if (!exactDate || this.isPastRestockDate(exactDate)) {
        this.setRestockMessage('');
        return;
      }
      const windowText = this.formatRestockWindow(exactDate);
      const calendarMonth = this.getRestockCalendarMonth(exactDate);
      this.setRestockMessage(windowText, calendarMonth);
    }

    /**
     * Initialize variant selection from URL parameter
     * This ensures that when a user clicks a variant link from collection deals,
     * the correct variant is selected on the product page
     */
    initializeFromUrlVariant() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      
      
      if (variantId && this.data && this.data.product) {
        // Find the variant with the matching ID
        const targetVariant = this.data.product.variants.find(v => v.id.toString() === variantId);
        
        
        if (targetVariant) {
          // Set flag to prevent URL updates during initialization
          this.isInitializingFromUrl = true;
          
          // Temporarily disable the change event listener to prevent interference
          this.removeEventListener('change', this.handleVariantChange.bind(this));
          
          // Set the option inputs to match this variant
          this.optionSelectors.forEach((selector, index) => {
            const optionValue = targetVariant.options[index];
            
            if (optionValue) {
              if (selector.dataset.selectorType === 'dropdown') {
                // For dropdown selectors, update the button text
                const button = selector.querySelector('.custom-select__btn');
                if (button) {
                  button.textContent = optionValue;
                }
              } else {
                // For radio button selectors, check the corresponding input
                const optionInput = selector.querySelector(`input[value="${optionValue}"]`);
                if (optionInput) {
                  optionInput.checked = true;
                  // Add a data attribute to help getSelectedOptions() find this input
                  optionInput.setAttribute('data-url-selected', 'true');
                } else {
                }
              }
            }
          });
          
          // Re-enable the change event listener after a short delay
          setTimeout(() => {
            this.addEventListener('change', this.handleVariantChange.bind(this));
            // Clear the flag after a delay to allow normal URL updates
            setTimeout(() => {
              this.isInitializingFromUrl = false;
            }, 100);
          }, 200);
        }
      }
    }

    /**
     * Force the correct variant selection from URL after all initialization is complete
     * This ensures the variant picker respects the URL parameter even if other code overrides it
     */
    /**
     * Align picker + form with a variant when opening quick-add from a card (collection shows ?variant= on card URL only).
     * @param {string|number} variantId
     */
    syncVariantFromQuickAdd(variantId) {
      if (variantId == null || variantId === '') return;
      this.originalVariantId = String(variantId);
      this.forceCorrectVariantFromUrl();
    }

    forceCorrectVariantFromUrl() {
      // Use the stored original variant ID to prevent it from being lost
      const originalVariantId = this.originalVariantId;
      
      
      if (originalVariantId && this.data && this.data.product) {
        const targetVariant = this.data.product.variants.find(v => v.id.toString() === originalVariantId);
        
        if (targetVariant) {
          // Set flag to prevent URL updates during forced correction
          this.isInitializingFromUrl = true;
          
          // Force set the option inputs again - ensure all selectors are updated
          this.optionSelectors.forEach((selector, index) => {
            const optionValue = targetVariant.options[index];
            if (optionValue) {
              if (selector.dataset.selectorType === 'dropdown') {
                const button = selector.querySelector('.custom-select__btn');
                if (button) {
                  button.textContent = optionValue;
                  // Also update the custom-select component's internal state if it exists
                  const customSelect = selector.querySelector('custom-select');
                  if (customSelect && customSelect.setValue) {
                    customSelect.setValue(optionValue);
                  }
                }
              } else {
                // Uncheck all inputs in this selector first
                const allInputs = selector.querySelectorAll('input.js-option');
                allInputs.forEach(input => {
                  input.checked = false;
                  input.removeAttribute('data-url-selected');
                });
                
                // Then check the correct input
                const optionInput = selector.querySelector(`input[value="${optionValue}"]`);
                if (optionInput) {
                  optionInput.checked = true;
                  // Add a data attribute to help getSelectedOptions() find this input
                  optionInput.setAttribute('data-url-selected', 'true');
                }
              }
            }
          });
          
          // Update the variant picker state
          this.variant = targetVariant;
          this.updateVariantInput();
          
          // Update all UI elements to reflect the URL variant
          this.updatePrice();
          this.updateWeight();
          this.updateBarcode();
          this.updateSku();
          this.updateHexCode();
          this.updateTransmissionDistance();
          this.updateRestockEstimate();
          this.updateBackorderText();
          this.updatePickupAvailability();
          this.updateAddToCartButton();
          this.updateAvailability();
          this.updateMedia();
          
          // Update swatch visibility and color labels
          const selectedOptions = this.getSelectedOptions();
          this.updateSwatchVisibility(selectedOptions);
          this.updateAllColorLabels();
          
          // Dispatch variant change event to notify other components
          this.dispatchEvent(new CustomEvent('on:variant:change', {
            bubbles: true,
            detail: {
              form: this.productForm,
              variant: this.variant,
              product: this.data.product
            }
          }));
          
          // Restore PDP URL to match variant (never on collection / in quick-add — would hijack filters + refresh)
          if (this.shouldMutateBrowserUrlForVariant()) {
            const currentUrl = new URL(window.location);
            const currentVariant = currentUrl.searchParams.get('variant');
            if (currentVariant !== originalVariantId) {
              window.history.replaceState({}, '', `${this.dataset.url}?variant=${originalVariantId}`);
            }
          }
          
          // Clear the flag after a delay to allow normal URL updates
          setTimeout(() => {
            this.isInitializingFromUrl = false;
          }, 100);
        }
      }
    }

    /**
     * Initialize the first available variant on page load
     * 
     * This method ensures that when the variant picker loads, it automatically
     * selects the first available variant and updates all UI elements accordingly.
     * This provides consistent behavior for bundle templates and regular product pages.
     * 
     * IMPORTANT: This method should NOT run if a variant is specified in the URL.
     * The URL variant takes precedence and should be enforced separately.
     */
    initializeFirstVariant() {
      // CRITICAL: Skip if URL has a variant parameter - URL variant takes precedence
      if (this.originalVariantId) {
        return;
      }
      
      // Find the first available variant
      const firstAvailableVariant = this.data.product.variants.find(variant => variant.available);
      
      if (firstAvailableVariant) {
        // Update all selectors to match the first available variant
        this.updateSelectorsToVariant(firstAvailableVariant);
        
        // Update variant picker state
        this.variant = firstAvailableVariant;
        this.updateVariantInput();
        
        // Update all UI elements (price, inventory, buttons, etc.)
        this.updateMedia();
        this.updatePrice();
        this.updateWeight();
        this.updateBarcode();
        this.updateSku();
        this.updateHexCode();
        this.updateTransmissionDistance();
        this.updateRestockEstimate();
        this.updateAddToCartButton();
        this.updateAvailability();
        
        // Update swatch visibility
        const selectedOptions = this.getSelectedOptions();
        this.updateSwatchVisibility(selectedOptions);
        
        // Dispatch variant change event to notify other components
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }
    }
  
    disableAddButtons() {
        // 禁用按钮
        $('.product-info .product-form__add-button').attr('disabled', 'disabled');
        $('quick-add-drawer .product-form__add-button').attr('disabled', 'disabled');
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */

    handleVariantChange(evt) {
     let operateSetting = $('.overallContent').attr('data-switch');
      if(operateSetting === 'true') {
         $('.product-info .product-form__add-button').attr('disabled', 'disabled')
        $('quick-add-drawer .product-form__add-button').attr('disabled', 'disabled')

      let variantId;
      if (this.variant) {
          variantId = this.variant.id;
      } else {
          // 处理未找到 variant 的情况
          variantId = null; // 或者其他默认值
      }
      let variantId1;
      let selectedVariant = this.getSelectedVariant();
      if (selectedVariant) {
          variantId1 = selectedVariant.id;
      } else {
          // 处理未找到选定变体的情况
          variantId1 = null; // 或者其他默认值
      }

       let dataQuickadd1 = $('quick-add-drawer .product-options').attr('data-quickadd');
           
       if(window.location.pathname.includes('cart') || dataQuickadd1) {
         if(variantId1 != null ) {
             this.executeOnceForVariantId(variantId1);
         }else {
            this.executeOnceForVariantId(variantId);
         }
        
        
        }else {
         if(window.location.pathname === '/'){
           this.executeOnceForVariantId(variantId1);
         }else{
            // 获取 PwzrGrid-direction-xs-column 盒子
          const container = document.querySelector('.PwzrGrid-direction-xs-column');
    
          // 获取该盒子中所有的 PwzrGrid-item 盒子
          const items = container.querySelectorAll('.PwzrGrid-item');
    
          // 获取数量
          const itemCount = items.length;
    
    
    
          // 判断当前 variantId 是否与上一个相同
          if (variantId === this.lastVariantId) {
            this.sameCount += 1;
          } else {
            this.lastVariantId = variantId; // 确保使用正确的变量名
            this.sameCount = 1;
          }
    
          if (itemCount > 1) {
            // 仅在这个PwzrGrid-item 盒子大于1时执行此操作
            // 根据 sameCount 的值执行相应操作
            if (this.sameCount === 2) {
              // 仅在计数为 2 时执行此操作
              this.executeOnceForVariantId(variantId);
              this.sameCount = 0; // 重置计数器
            }
          } else {
            // 仅在这个PwzrGrid-item 盒子为 1 时执行此操作
            this.executeOnceForVariantId(variantId1);
          }
         }

        }
     
      }
     



      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.getSelectedVariant();

      // Always update URL if a variant is selected, regardless of availability
      // BUT: Skip URL update if we're initializing from URL (to prevent overwriting the correct URL)
      if (this.variant) {
        // Only update URL if not initializing from URL
        // During initialization, forceCorrectVariantFromUrl() will handle URL restoration
        if (!this.isInitializingFromUrl) {
          this.updateUrl(evt);
        }
        this.updateVariantInput();
      } else {
        // Try to find the variant from selected options even if it's out of stock
        const selectedOptions = this.getSelectedOptions();
        if (selectedOptions.length > 0) {
          const matchingVariant = this.data.product.variants.find(variant => 
            variant.options.every((option, index) => option === selectedOptions[index])
          );
          
          if (matchingVariant) {
            // Set the variant even if it's out of stock
            this.variant = matchingVariant;
            // Only update URL if not initializing from URL
            // During initialization, forceCorrectVariantFromUrl() will handle URL restoration
            if (!this.isInitializingFromUrl) {
              this.updateUrl(evt);
            }
            this.updateVariantInput();
          }
        }
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      
      // Update swatch visibility based on new selection
      const selectedOptions = this.getSelectedOptions();
      this.updateSwatchVisibility(selectedOptions);
      
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateHexCode();
      this.updateTransmissionDistance();
      this.updateRestockEstimate();
      VariantPicker.updateLabelText(evt);
      

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }

      }));

      // Update media after variant change event is dispatched to ensure proper timing
      if (this.variant) {
        // Use requestAnimationFrame to ensure DOM updates are complete
        requestAnimationFrame(() => {
          this.updateMedia();
          
          // Also trigger a delayed media update to handle any timing issues
          setTimeout(() => {
            this.updateMedia();
          }, 100);
        });
      }

    }
    executeOnceForVariantId(variantId,dataQuickadd) {

      // 检查 variantId 是否存在
      if (variantId) {
        $('.product-formAdd-button').attr('data-variant', variantId);
        
        if(dataQuickadd) {
               $('quick-add-drawer .quantity_products').val(1);
          // 调用单次处理方法
              Inventory.fetchProductData(variantId, 1, false,true);

        }else {
          // 检查当前路径是否包含 'products'
        if (window.location.pathname.includes('products')|| window.location.pathname === '/') {
          // 获取 class 为 productInventory_variantId 的 input 的值
          let variantInput = document.querySelector('.productInventory_variantId');
          let variantInputValue = variantInput ? variantInput.value : null;
          $('.quantity_products').val(1);
          // 如果 miniCartBox 不存在，直接获取页面上的 input 值
          const inputValue = Number($('.quantity_products').val());
          let inputBox = false;
          let isVarantId = false;

          // 检查 mini-cart__line-item-list 盒子是否存在
          let miniCartBox = document.querySelector('.mini-cart__line-item-list');
          if (miniCartBox) {
            // 遍历 mini-cart__line-item 元素
            let lineItems = miniCartBox.querySelectorAll('.mini-cart__line-item');
            let itemsData = [];

            lineItems.forEach((item) => {
              // 使用 jQuery 包装当前行元素
              let selectedItem = $(item);
              // 获取当前行的 input 值
              let selectedInputValue = selectedItem.find('.quantity-selectorValue').val();
              // 获取当前行的 variantId
              let cartVariantId = selectedItem.attr('data-variant-id');
              if (cartVariantId === variantId) {
                isVarantId = true;
              }
              // 根据 variantId 和 cartVariantId 是否匹配来设置 inputValue
              let inputValue = (cartVariantId === variantId) ? selectedInputValue : $('.quantity_products').val();

              // 将当前行的 item 和 inputValue 保存到 itemsData 数组
              itemsData.push({ inputValue: inputValue });
            });

            if (isVarantId) {
              // 使用批量处理方法处理 itemsData
                Inventory.batchFetchProductData(variantId, itemsData, inputBox,false);
            } else {

              // 调用单次处理方法
              Inventory.fetchProductData(variantId, inputValue, inputBox,false);
            }
          } else {
            // 调用单次处理方法
            Inventory.fetchProductData(variantId, inputValue, inputBox,false);

            // 检查是否存在 inventoryList,stockType
            if (localStorage.getItem('stockType') || localStorage.getItem('inventoryList')) {
              // 存在则删除
              localStorage.removeItem('controlTmark');
              localStorage.setItem('stockType', 0);
            }
          }
           // 获取购物车中的商品列表元素，如果未找到则设为空字符串
          const cartLineItemList = document.querySelector('.mini-cart__line-item-list') || '';

          // 从本地存储中获取 inventoryList 数组，如果不存在则设为空数组
          const inventoryList = JSON.parse(localStorage.getItem('inventoryList')) || [];
        

          // 如果存在购物车商品列表
          if (cartLineItemList != '') {
            // 获取购物车中所有商品行元素
            const cartLineItems = cartLineItemList.querySelectorAll('.mini-cart__line-item');

            // 检查购物车中是否已存在相同 variant ID 的商品行
            let isSame = Array.from(cartLineItems).find(item => item.getAttribute('data-variant-id') == variantId);

            // 如果存在相同商品行
            if (isSame != undefined) {
              // 遍历购物车中的每个商品行元素
              cartLineItems.forEach(function (item) {
                // 获取商品行的 variant ID
                let itemCartId = item.getAttribute('data-variant-id');

                // 在 inventoryList 中查找匹配的 id
                const itemCartIdMatch = inventoryList.find(inventoryItem => inventoryItem.id === itemCartId);

                // 如果找到匹配项，则设置商品行的 data-odoo 和 data-amz 属性
                if (itemCartIdMatch) {
                  $(item).find('.quantity-selectorValue').attr('data-odoo', itemCartIdMatch.odoo);
                  $(item).find('.quantity-selectorValue').attr('data-amz', itemCartIdMatch.amz);
                  $(item).find('.productsButton').attr('data-odoo', itemCartIdMatch.odoo);
                  $(item).find('.productsButton').attr('data-amz', itemCartIdMatch.amz);
                }
              });
            }
          }
        }
        }
      }
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
      
      // Hide/show add-to-cart button based on availability
      if (variantAvailable) {
        this.addBtn.style.display = '';
      } else {
        this.addBtn.style.display = 'none';
      }
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }

    }



    /**
     * SMART SELECTION HELPER METHODS
     * These methods enable clicking on options that exist anywhere, not just with current selection
     */

    /**
     * Gets the selector index for a given input element
     * Used to determine which option type (diameter, color, etc.) was clicked
     * @param {HTMLElement} input - The input element that was clicked
     * @returns {number} The selector index (0=diameter, 1=net weight, 2=color, etc.)
     */
    getSelectorIndex(input) {
      for (let i = 0; i < this.optionSelectors.length; i++) {
        if (this.optionSelectors[i].contains(input)) {
          return i;
        }
      }
      return -1;
    }

    /**
     * Checks if an option value exists in any variant (permissive check)
     * This is the key method that enables smart selection - it checks if an option
     * exists anywhere, not just with the current selection context
     * @param {string} optionValue - The option value to check (e.g., "2.85mm", "Orange")
     * @param {number} selectorIndex - The selector index (which option type)
     * @returns {boolean} True if the option exists in any variant
     */
    checkIfOptionHasAnyVariant(optionValue, selectorIndex) {
      return this.data.product.variants.some(variant => 
        variant.options[selectorIndex] === optionValue
      );
    }

    /**
     * Finds the best available variant with a specific option value
     * Used to auto-select the best matching variant when user clicks an option
     * Prioritizes keeping the same color if it exists with the new option
     * @param {string} optionValue - The option value to find (e.g., "5kg")
     * @param {number} selectorIndex - The selector index (which option type)
     * @returns {object|null} The best matching variant or null if none found
     */
    findFirstAvailableVariant(optionValue, selectorIndex) {
      const currentOptions = this.getSelectedOptions();
      
      // Find the color selector index dynamically
      let colorSelectorIndex = -1;
      for (let i = 0; i < this.optionSelectors.length; i++) {
        const isColorSelector = this.optionSelectors[i].querySelector('.opt-label--swatch') !== null;
        if (isColorSelector) {
          colorSelectorIndex = i;
          break;
        }
      }
      
      // First, try to find a variant that keeps the current color (if we're not changing the color itself)
      if (colorSelectorIndex !== -1 && selectorIndex !== colorSelectorIndex) {
        const currentColor = currentOptions[colorSelectorIndex]; // Get current color
        
        const variantWithSameColor = this.data.product.variants.find(variant => 
          variant.options[selectorIndex] === optionValue && 
          variant.options[colorSelectorIndex] === currentColor
        );
        
        if (variantWithSameColor) {
          return variantWithSameColor;
        }
      }
      
      // If no variant found with same color, or if we're changing the color itself, find first available
      return this.data.product.variants.find(variant => 
        variant.options[selectorIndex] === optionValue
      );
    }

    /**
     * Updates all selectors to match a specific variant
     * This is called after finding a new variant to update all option selectors
     * to reflect the new selection (e.g., when clicking 2.85mm, update color to Orange)
     * @param {object} variant - The variant to match all selectors to
     */
    updateSelectorsToVariant(variant) {
      this.optionSelectors.forEach((selector, index) => {
        if (variant.options[index]) {
          const optionValue = variant.options[index];
          
          if (selector.dataset.selectorType === 'dropdown') {
            // Handle dropdown selectors (custom select components)
            const customSelectBtn = selector.querySelector('.custom-select__btn');
            if (customSelectBtn) {
              customSelectBtn.textContent = optionValue;
            }
          } else {
            // Handle radio button selectors (standard option buttons)
            const input = selector.querySelector(`input[value="${optionValue}"]`);
            if (input) {
              input.checked = true;
            }
          }
        }
      });
    }

    /**
     * Updates swatch visibility based on current selection
     * 
     * SMART SELECTION LOGIC:
     * - Color options (swatches): Use restrictive logic - only show colors that work with current selection
     * - Non-color options (diameter, net weight, etc.): Use permissive logic - show if option exists anywhere
     * 
     * This enables the smart selection behavior where users can click on options that exist
     * anywhere (like 2.85mm) even if they don't work with the current selection (like 1.75mm + Black)
     */
    updateSwatchVisibility(selectedOptions) {
      
      // Get all option selectors
      this.optionSelectors.forEach((selector, selectorIndex) => {
        // Skip dropdown selectors - they handle their own visibility logic
        const isDropdownSelector = selector.dataset.selectorType === 'dropdown';
        if (isDropdownSelector) return;
        
        const options = selector.querySelectorAll('.js-option');
        
        // Determine if this is a color selector
        const isColorSelector = selector.querySelector('.opt-label--swatch') !== null;
        
        options.forEach((optionEl) => {
          const optionValue = optionEl.value;
          let hasValidVariant = false;
          
          if (isColorSelector) {
            // COLOR OPTIONS: Use restrictive logic (only show if works with current selection)
            // This ensures colors only appear when they're actually available with current selection
            this.data.product.variants.forEach((variant) => {
              // Check if this variant matches the current selection context
              let matchesCurrentSelection = true;
              
              // Check all selected options except the current one
              for (let i = 0; i < selectedOptions.length; i++) {
                if (i !== selectorIndex && variant.options[i] !== selectedOptions[i]) {
                  matchesCurrentSelection = false;
                  break;
                }
              }
              
              // Check if this variant has the current option value
              if (matchesCurrentSelection && variant.options[selectorIndex] === optionValue) {
                hasValidVariant = true;
              }
            });
          } else {
            // NON-COLOR OPTIONS: Use permissive logic (show if exists anywhere)
            // This enables smart selection - users can click on options that exist anywhere
            // Example: User can click 2.85mm even when Black is selected (because 2.85mm + Orange exists)
            hasValidVariant = this.checkIfOptionHasAnyVariant(optionValue, selectorIndex);
          }
          
          // Try multiple ways to find the label/parent element
          let label = optionEl.closest('label');
          if (!label) {
            // Try finding by the input's ID
            const inputId = optionEl.id;
            if (inputId) {
              label = document.querySelector(`label[for="${inputId}"]`);
            }
          }
          if (!label) {
            // Try finding the parent element
            label = optionEl.parentElement;
          }
          
          if (label && label.style !== undefined) {
            if (isColorSelector) {
              // For color options: keep current behavior (hide/show)
              if (hasValidVariant) {
                label.style.display = '';
                label.classList.remove('swatch-hidden');
                optionEl.disabled = false;
                label.classList.remove('option-disabled');
              } else {
                label.style.display = 'none';
                label.classList.add('swatch-hidden');
              }
            } else {
              // For non-color options: always show, but disable when unavailable
              label.style.display = '';
              label.classList.remove('swatch-hidden');
              
              if (hasValidVariant) {
                optionEl.disabled = false;
                label.classList.remove('option-disabled');
              } else {
                optionEl.disabled = true;
                label.classList.add('option-disabled');
              }
            }
          }
        });
      });

      this.updateNewSwatchHighlights(selectedOptions);
    }

    /**
     * @param {*} raw Metafield creation_date (YYYY-MM-DD or ISO)
     * @returns {boolean} true if within last 60 days and not in the future
     */
    static isCreationDateWithinNewWindow(raw) {
      if (raw == null || raw === '') return false;
      const s = String(raw).trim();
      if (!s) return false;
      const iso = s.includes('T') ? s : `${s}T12:00:00`;
      const t = Date.parse(iso);
      if (Number.isNaN(t)) return false;
      const now = Date.now();
      if (t > now) return false;
      const maxAgeMs = 60 * 86400 * 1000;
      return now - t <= maxAgeMs;
    }

    /**
     * Variant backing a swatch for the current non-color selections (e.g. packaging + color).
     */
    findVariantForSwatchOption(selectorIndex, swatchValue, selectedOptions) {
      const variants = this.data.product.variants;
      const n = selectedOptions.length;
      const strict = variants.find((variant) => {
        if (variant.options[selectorIndex] !== swatchValue) return false;
        for (let i = 0; i < n; i += 1) {
          if (i === selectorIndex) continue;
          const sel = selectedOptions[i];
          if (sel == null || sel === '') continue;
          if (variant.options[i] !== sel) return false;
        }
        return true;
      });
      if (strict) return strict;
      return variants.find((v) => v.options[selectorIndex] === swatchValue) || null;
    }

    /**
     * Sync "new" swatch UI when option groups change (matches Liquid variant-for-swatch context).
     */
    updateNewSwatchHighlights(selectedOptions) {
      if (!this.data || !this.data.product || !this.data.formatted) return;

      const enabled =
        typeof theme !== 'undefined' &&
        theme.settings &&
        theme.settings.newVariantSwatchEnable !== false;
      const badgeText =
        (typeof theme !== 'undefined' &&
          theme.settings &&
          theme.settings.newVariantSwatchBadgeText) ||
        'New';

      this.optionSelectors.forEach((selector, selectorIndex) => {
        if (selector.dataset.selectorType === 'dropdown') return;
        if (!selector.querySelector('.opt-label--swatch')) return;

        selector.querySelectorAll('.js-option').forEach((input) => {
          let label = input.nextElementSibling;
          if (!label || !label.classList.contains('opt-label')) {
            label = input.id ? this.querySelector(`label[for="${input.id}"]`) : null;
          }
          if (!label || !label.classList.contains('opt-label--swatch')) return;

          const swatchValue = input.value;
          const variant = this.findVariantForSwatchOption(selectorIndex, swatchValue, selectedOptions);
          let show = false;
          let hex = '';
          if (enabled && variant) {
            const fv = this.data.formatted[variant.id];
            const cd = fv && fv.metafields && fv.metafields.custom && fv.metafields.custom.creation_date;
            show = VariantPicker.isCreationDateWithinNewWindow(cd);
            const hx = fv && fv.metafields && fv.metafields.custom && fv.metafields.custom.hex_code;
            if (hx != null && hx !== '') hex = String(hx).trim();
          }

          label.querySelectorAll('.new-pill, .pulse-ring').forEach((el) => el.remove());

          let st = label.getAttribute('style') || '';
          st = st.replace(/\s*--swatch-new-ring-color:\s*[^;]+;?/gi, '').replace(/;\s*;/g, ';').trim();
          if (st.endsWith(';')) st = st.slice(0, -1).trim();

          label.classList.toggle('opt-label--swatch-new', show);

          if (show && hex) {
            st = st ? `${st}; --swatch-new-ring-color: ${hex}` : `--swatch-new-ring-color: ${hex}`;
          }
          if (st) label.setAttribute('style', st);
          else label.removeAttribute('style');

          if (show) {
            const pill = document.createElement('span');
            pill.className = 'new-pill';
            pill.textContent = badgeText;
            const ring = document.createElement('span');
            ring.className = 'pulse-ring';
            ring.setAttribute('aria-hidden', 'true');
            const anchor =
              label.querySelector('.opt-label__media') ||
              label.querySelector('.variant-swatch') ||
              label.querySelector('.visually-hidden.js-value') ||
              label.firstElementChild;
            if (anchor) {
              label.insertBefore(pill, anchor);
              label.insertBefore(ring, anchor);
            } else {
              label.appendChild(pill);
              label.appendChild(ring);
            }
          }
        });
      });
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;
      const selectedOptions = this.getSelectedOptions();

      if (!this.variant) {
        currVariant = { options: selectedOptions };
      }
      
      
      // Dynamic swatch filtering based on current selection
      this.updateSwatchVisibility(selectedOptions);

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === selectedOptions[i] || selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }

    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant) return;

      if (this.section.matches('quick-add-drawer')) {
        if (this.variant.featured_media) {
          this.section.updateMedia(this.variant.featured_media.id);
        }
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) {
        } else {

          if (this.variant.featured_media) {
            const variantMedia = this.mediaGallery.querySelector(
              `[data-media-id="${this.variant.featured_media.id}"]`
            );
            if (variantMedia) {
              this.mediaGallery.setActiveMedia(variantMedia, true, true);
            }
          }
          
          // Always trigger a media update event to ensure other components are notified
          // This is important when variants change but have the same featured media
          this.mediaGallery.dispatchEvent(new CustomEvent('variant:media:update', {
            detail: { variant: this.variant }
          }));
        }
      }
      
      // Always update Rio gallery if it exists (regardless of media gallery)
      this.updateRioGallery();
    }

    /**
     * Updates Rio gallery images when variants change
     */
    updateRioGallery() {
      // Check if Rio gallery exists and update it
      const rioGallery = document.querySelector('.rio-media-gallery');
      if (rioGallery && this.variant) {
        // Use a small delay to ensure DOM is ready
        setTimeout(() => {
          // Find the main image in the Rio gallery
          const mainImage = rioGallery.querySelector('img');
          
          if (mainImage && this.variant.featured_media) {
            // Update the image source to match the variant's featured media
            const imageUrl = this.variant.featured_media.src || this.variant.featured_media.preview_image.src;
            if (imageUrl) {
              mainImage.src = imageUrl;
              mainImage.alt = this.variant.title || this.data.product.title;
              
              // Also update any data-src attributes for lazy loading
              if (mainImage.dataset.src) {
                mainImage.dataset.src = imageUrl;
              }
            }
          }
          
          // Trigger multiple event types that Rio gallery might be listening for
          const events = [
            new CustomEvent('variant:change', { detail: { variant: this.variant } }),
            new CustomEvent('on:variant:change', { detail: { variant: this.variant } }),
            new Event('change', { bubbles: true }),
            new Event('input', { bubbles: true })
          ];
          
          events.forEach(event => {
            rioGallery.dispatchEvent(event);
          });
          
          // Also dispatch on document level in case Rio gallery listens globally
          events.forEach(event => {
            document.dispatchEvent(event);
          });
          
          // Try to directly update Rio gallery's internal state if it has any
          if (window.rioGallery && typeof window.rioGallery.updateVariant === 'function') {
            window.rioGallery.updateVariant(this.variant);
          }
          
          // Try to find and trigger any Rio gallery methods
          const rioGalleryElement = rioGallery.querySelector('[data-rio-gallery]');
          if (rioGalleryElement && rioGalleryElement.updateVariant) {
            rioGalleryElement.updateVariant(this.variant);
          }
          
          // Rio: only touch the real product URL (same rule as updateUrl — never from collection / drawer)
          if (this.shouldMutateBrowserUrlForVariant()) {
            const currentUrl = new URL(window.location);
            currentUrl.searchParams.set('variant', this.variant.id);
            window.history.replaceState({}, '', currentUrl);
            window.dispatchEvent(new PopStateEvent('popstate', { state: {} }));
          }
        }, 50); // Small delay to ensure DOM updates are complete
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Notify Regios Discounts (DOPP) of a variant change so it can re-apply discounted
     * prices. Fires both the variant-change event AND calls themeInterop.updateOnPagePrices.
     */
    notifyRegiosDoppVariantChange() {
      if (!this.variant || !this.variant.id) return;
      if (this.dataset.regiosDoppVariantSync === 'false') return;

      let quantity = 1;
      try {
        const qtyInput =
          this.productForm?.querySelector('input[name="quantity"]') ||
          this.section?.querySelector('.js-product-form-main input[name="quantity"]') ||
          this.section?.querySelector('input[name="quantity"]');
        if (qtyInput && qtyInput.value) {
          const n = parseInt(qtyInput.value, 10);
          if (!Number.isNaN(n) && n > 0) quantity = n;
        }
      } catch (e) {
        quantity = 1;
      }

      const quickAddDrawer = this.closest('quick-add-drawer');
      const scope = quickAddDrawer || this.section;

      const buildInteropArgs = () => {
        if (!this.data?.product || !this.variant) return null;
        const p = this.data.product;
        const v = this.variant;
        const regularPriceInCents = v.price;
        let compareAtPriceInCents = null;
        if (v.compare_at_price && v.compare_at_price > regularPriceInCents) {
          compareAtPriceInCents = v.compare_at_price;
        }
        const variants = (p.variants || []).map((vv) => ({
          id: vv.id,
          title: vv.title,
          priceInCents: vv.price,
          compareAtPriceInCents:
            vv.compare_at_price && vv.compare_at_price > vv.price ? vv.compare_at_price : null
        }));
        const args = {
          productId: p.id,
          variantId: v.id,
          regularPriceInCents,
          compareAtPriceInCents,
          quantity,
          handle: p.handle,
          vendor: p.vendor,
          tags: p.tags,
          variants
        };
        if (p.handle) {
          const base = window.Shopify?.routes?.root || '/';
          args.url = `${base}products/${p.handle}`;
        }
        return args;
      };

      const runInterop = () => {
        try {
          const interop = window.RegiosDOPP?.api?.v0?.themeInterop;
          if (!interop?.updateOnPagePrices) return;
          const args = buildInteropArgs();
          if (!args) return;
          if (scope) {
            scope.setAttribute('data-regios-dopp-generic-product-id', String(args.productId));
          }
          interop.updateOnPagePrices(scope, 'PRODUCT_PAGE', args).catch(() => {});
        } catch (e) {
          /* Regios optional */
        }
      };

      queueMicrotask(() => {
        try {
          const detail = {
            selectedVariant: {
              id: this.variant.id,
              price: this.variant.price
            },
            quantity
          };
          if (this.data?.product?.id) detail.productId = this.data.product.id;
          window.dispatchEvent(
            new CustomEvent('regios-dopp:variant-change', {
              bubbles: true,
              detail
            })
          );
        } catch (e) {
          /* Regios optional */
        }

        if (window.RegiosDOPP?.api?.v0?.themeInterop?.updateOnPagePrices) {
          queueMicrotask(runInterop);
        } else if (typeof window.RegiosDOPP !== 'undefined') {
          window.addEventListener('regios-dopp:api-initialized', runInterop, { once: true });
          requestAnimationFrame(runInterop);
        }
      });
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      const quickAddDrawer = this.closest('quick-add-drawer');

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        const fp = this.data.formatted[this.variant.id];
        const nextCurrent = (fp.priceNoCurrency || fp.price || '').trim();
        const nextWas = (fp.compareAtPriceNoCurrency || fp.compareAtPrice || '').trim();
        if (priceCurrentEl.innerHTML.trim() !== nextCurrent) priceCurrentEl.innerHTML = nextCurrent;
        if (priceWasEl && priceWasEl.innerHTML.trim() !== nextWas) priceWasEl.innerHTML = nextWas;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;

      if (this.variant) {
        this.notifyRegiosDoppVariantChange();
      }
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0 || !this.variant || !this.variant.id) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the custom hex code.
     */
    updateHexCode() {
      this.hexCode = this.hexCode || this.section.querySelector('.product-hex-code__value');
      this.hexCodeContainer = this.hexCodeContainer || this.section.querySelector('.product-hex-code');
      if (!this.hexCode || !this.hexCodeContainer || !this.variant) return;

      // Get metafields from the formatted data using variant ID
      const formattedVariant = this.data.formatted[this.variant.id];
      const hexCodeValue = formattedVariant?.metafields?.custom?.hex_code;
      
      this.hexCode.textContent = hexCodeValue || '';
      this.hexCodeContainer.hidden = !hexCodeValue;
    }

    /**
     * Updates the transmission distance.
     */
    updateTransmissionDistance() {
      this.transmissionDistance = this.transmissionDistance || this.section.querySelector('.product-transmission-distance__value');
      this.transmissionDistanceContainer = this.transmissionDistanceContainer || this.section.querySelector('.product-transmission-distance');
      if (!this.transmissionDistance || !this.transmissionDistanceContainer) return;

      // Safety check: ensure variant exists before accessing its properties
      if (!this.variant || !this.variant.id) return;

      // Get metafields from the formatted data using variant ID
      const formattedVariant = this.data.formatted[this.variant.id];
      const tdValue = formattedVariant?.metafields?.custom?.transmission_distance;
      
      this.transmissionDistance.textContent = tdValue || '';
      this.transmissionDistanceContainer.hidden = !tdValue;
    }

    /**
     * Updates all color labels to reflect the current variant selection
     * This is used for smart selection to ensure color text updates properly
     */
    updateAllColorLabels() {
      if (!this.variant) return;
      
      // Update color text labels for all selectors
      this.optionSelectors.forEach((selector, index) => {
        if (selector.dataset.selectorType === 'dropdown') return;
        
        const colorText = selector.querySelector('.js-color-text');
        if (colorText && this.variant.options[index]) {
          colorText.textContent = this.variant.options[index];
        }
      });
    }

    /**
     * Simulates clicking the color option to trigger app events (like variant image apps)
     * This ensures that third-party apps receive the proper events when smart selection occurs
     */
    simulateColorOptionClick(variant) {
      if (!variant) return;
      
      // Find the color option that matches the variant and simulate clicking it
      this.optionSelectors.forEach((selector, index) => {
        if (selector.dataset.selectorType === 'dropdown') return;
        
        const isColorSelector = selector.querySelector('.opt-label--swatch') !== null;
        
        if (isColorSelector && variant.options[index]) {
          const optionValue = variant.options[index];
          const colorInput = selector.querySelector(`input[value="${optionValue}"]`);
          
          if (colorInput) {
            // Always simulate the events to trigger app listeners, even if already checked
            // This ensures variant image apps receive the events they need
            colorInput.checked = true;
            
            // Dispatch multiple event types to trigger various app listeners
            const changeEvent = new Event('change', { bubbles: true });
            colorInput.dispatchEvent(changeEvent);
            
            const clickEvent = new Event('click', { bubbles: true });
            colorInput.dispatchEvent(clickEvent);
            
            // Some apps listen for input events
            const inputEvent = new Event('input', { bubbles: true });
            colorInput.dispatchEvent(inputEvent);
            
            // Trigger custom variant change event that some apps might listen for
            const variantChangeEvent = new CustomEvent('variant-change', { 
              bubbles: true, 
              detail: { variant: variant, option: optionValue } 
            });
            colorInput.dispatchEvent(variantChangeEvent);
          }
        }
      });
    }

    /**
     * Only sync ?variant= into the address bar on the real PDP for this product.
     * Collection/search + quick-add drawer must never replace the collection URL with /products/...?variant=.
     */
    shouldMutateBrowserUrlForVariant() {
      if (this.closest('quick-add-drawer')) return false;
      if (!this.dataset.url) return true;
      try {
        const productPath = new URL(this.dataset.url, window.location.origin).pathname;
        if (window.location.pathname !== productPath) return false;
      } catch (e) {
        return true;
      }
      return true;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      if (!this.shouldMutateBrowserUrlForVariant()) return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }


    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector, index) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          // For radio button selectors, find the checked input
          const checkedInput = selector.querySelector('input:checked');
          
          if (checkedInput) {
            selectedOptions.push(checkedInput.value);
          } else {
            // Try to find the input that was set by initializeFromUrlVariant
            // Look for inputs that have been programmatically set
            const allInputs = selector.querySelectorAll('input.js-option');
            let foundInput = null;
            
            // Check if any input has been set by our URL initialization
            for (const input of allInputs) {
              if (input.checked || input.hasAttribute('data-url-selected')) {
                foundInput = input;
                break;
              }
            }
            
            if (foundInput) {
              selectedOptions.push(foundInput.value);
            } else {
              // Final fallback: get the first visible option
              const firstOption = selector.querySelector('input.js-option');
              if (firstOption) {
                selectedOptions.push(firstOption.value);
              } else {
                selectedOptions.push(null);
              }
            }
          }
        }
      });

      return selectedOptions;
    }





    /**
     * Gets the product data.
     * @returns {?object}
     */
   
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      try {
        const data = JSON.parse(dataEl.textContent);
        return data;
      } catch (error) {
        console.error('JSON Parse Error:', error);
        return null;
      }
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    

      getSelectedVariant() {
         
        let operateSetting = $('.overallContent').attr('data-switch');
      
         
              if(operateSetting === 'true'){
                // 先禁用按钮
                   this.disableAddButtons();
                
                 const selectedOptions = this.getSelectedOptions();
                 
                 
                  let vids = this.data.product.variants.find(
                      (v) => v.options.every((val, index) => val === selectedOptions[index])
                  );
                 
                 
                  if (!vids) return; // 确保找到了对应的变体
                
                  let dataQuickadd = $('quick-add-drawer .product-options').attr('data-quickadd');
                 // 获取 product-options 盒子
                  const optionContent = document.querySelector('.product-options');
            
                  // 获取该盒子中所有的 option-selector 盒子
                  const optionList = optionContent.querySelectorAll('.option-selector');
            
                  // 获取数量
                  const optionCount = optionList.length;
                  let quickId = vids.id;
                 // 判断当前 quickId 是否与上一个相同
                  if (quickId === this.lastVariantId) {
                    this.sameCount1 += 1;
                  } else {
                    this.lastVariantId = quickId; // 确保使用正确的变量名
                    this.sameCount1 = 1;
                  }
             
                    if (optionCount > 1) {
                    // 仅在这个option-selector 盒子大于1时执行此操作
                    // 根据 sameCount1 的值执行相应操作
                    if (this.sameCount1 === 2) {
                      // 仅在计数为 2 时执行此操作
                      this.executeOnceForVariantId(quickId, dataQuickadd);
                      this.sameCount1 = 0; // 重置计数器
                  
                    }
                  } else {
                 
                    // 仅在这个option-selector 盒子为 1 时执行此操作
                    this.executeOnceForVariantId(quickId, dataQuickadd);
                  }
                    
                
                return vids;
              } else if (operateSetting === 'false') {
                 const selectedOptions = this.getSelectedOptions();
                 
                 
                 const foundVariant = this.data.product.variants.find(
                    (v) => v.options.every((val, index) => val === selectedOptions[index])
                  );
                  
                 
                 return foundVariant;
              }
                      
       


      }

   }


  customElements.define('variant-picker', VariantPicker);
}

/** BFCache restore: repaint swatch labels so border/box-shadow and ::before stay aligned */
if (!window.__polymakerSwatchPageshow) {
  window.__polymakerSwatchPageshow = true;
  window.addEventListener(
    'pageshow',
    (event) => {
      if (!event.persisted) return;
      requestAnimationFrame(() => {
        document.querySelectorAll('label[data-swatch].opt-label--swatch').forEach((el) => {
          void el.offsetWidth;
        });
      });
    },
    { passive: true }
  );
}
